import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import CinLin from './CinLin.vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Darkmode from 'darkmode-js'

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueAxios, axios);

new Vue({
  render: h => h(CinLin),
}).$mount('#cinlin');

const options = {
  mixColor: '#fff', // default: '#fff'
  backgroundColor: '#fff',  // default: '#fff'
  buttonColorDark: '#100f2c',  // default: '#100f2c'
  buttonColorLight: '#fff', // default: '#fff'
  label: '🌓', // default: ''
};

new Darkmode(options).showWidget();